import { connect } from 'react-redux';
import * as R from 'ramda';
import PrimaryStep2 from './PrimaryStep2';
import { getStoreValueByProp } from '../../store/sequencingWizardSlice';

const mapState = R.applySpec({
  loading: getStoreValueByProp(['locationsLoading']),
});

export default connect(mapState, {})(PrimaryStep2);
